import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import environment from './environments';

const firebaseConfig = {
    apiKey: environment.firebase?.apiKey || "AIzaSyDvvjCss5Vi5FBngIxwbYIwVyGuDeu59hc",
    authDomain: environment.firebase?.authDomain || "edify-firebase.firebaseapp.com",
    projectId: environment.firebase?.projectId || "edify-firebase",
    storageBucket: environment.firebase?.storageBucket || "edify-firebase.firebasestorage.app",
    messagingSenderId: environment.firebase?.messagingSenderId || "262004944712",
    appId: environment.firebase?.appId || "1:262004944712:web:63581cf92f3a1950124d7d",
    measurementId: environment.firebase?.measurementId || "G-XQMBGFQNSB"
  };
  
  const app = initializeApp(firebaseConfig);
  const analytics = getAnalytics(app);

  export default { app, analytics, firebaseConfig };